import { useCallback, useEffect } from 'react';

import { ResponseUserData } from '@/api/types';

interface IUseGAUserSystems {
  clearUserSystems: () => void;
}

export function useGAUserSystems(systems?: ResponseUserData['data']['systems']): IUseGAUserSystems {
  useEffect(() => {
    // @ts-ignore
    if (!window.gtag || !systems?.length) return;
    // @ts-ignore
    window.gtag('config', {
      systems,
    });
  }, [systems]);

  const clearUserSystems = useCallback(() => {
    // @ts-ignore
    if (!window.gtag) return;
    // @ts-ignore
    window.gtag('config', { systems: null });
  }, []);

  return { clearUserSystems };
}
